import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-navy py-10" data-id="element-58" data-mp="207t4gfx6vxoq">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-4 text-center sm:px-6" data-id="element-59" data-mp="207b1l0g0ul7u">
        <p className="font-heading text-lg font-bold uppercase tracking-wide text-white" data-id="element-60" data-mp="2f41z1464xmut">
          📚 Matemáticas Listo
        </p>
        <p className="text-sm text-white/70" data-id="element-61" data-mp="1mfwfuluqc5x3">Para profesores que quieren clases listas sin estrés.</p>
        <a href="mailto:manualeslistos@gmail.com" className="flex items-center gap-1.5 text-sm text-white/70 transition-colors hover:text-orange" data-id="element-62" data-mp="1hhbfmmfh9m8n">
          <MailIcon size={14} data-id="element-63" data-mp="1w7sgo4o7aa50" />
          manualeslistos@gmail.com
        </a>
        <p className="text-xs text-white/40" data-id="element-64" data-mp="1rdxxd2cibx6g">© 2024 Matemáticas Listo. Todos los derechos reservados.</p>
      </div>
    </footer>;
}